export const appPageTransition = {"name":"page","mode":"out-in"}

export const appLayoutTransition = {"name":"page","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appHead = {"link":[{"rel":"icon","href":"/favicon-192.png","type":"image/png","sizes":"192x192"},{"rel":"icon","href":"/favicon-256.png","type":"image/png","sizes":"256x256"},{"rel":"icon","href":"/favicon-384.png","type":"image/png","sizes":"384x384"},{"rel":"icon","href":"/favicon-512.png","type":"image/png","sizes":"512x512"},{"rel":"icon","href":"/favicon-696.svg","type":"image/svg+xml","sizes":"any"},{"rel":"icon","href":"/favicon-dark.png","type":"image/png","media":"(prefers-color-scheme: dark)","sizes":"520x521"},{"rel":"icon","href":"/favicon-dark.svg","type":"image/svg+xml","media":"(prefers-color-scheme: dark)","sizes":"any"},{"rel":"icon","href":"/favicon-light.svg","type":"image/svg+xml","media":"(prefers-color-scheme: light)","sizes":"any"},{"rel":"icon","href":"/favicon-mask.svg","type":"image/svg+xml","sizes":"any"},{"rel":"icon","href":"/favicon.png","type":"image/png","sizes":"520x521"},{"rel":"icon","href":"/favicon.svg","type":"image/svg+xml","sizes":"any"},{"rel":"icon","href":"/safari-favicon.png","type":"image/png","sizes":"512x512"},{"rel":"icon","href":"/safari-favicon.svg","type":"image/svg+xml","sizes":"any"}],"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"property":"og:type","content":"website"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{}}

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false